import { Tabs, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import PaypalAccount from "./PaypalAccount"
import styles from "./index.module.css"
import { StripeAccount } from "../../StripeAccount"
import { PAYPAL_TAB, STRIPE_TAB } from "./constants"
import { isFeatureEnabled } from "config/features"
import { Paragraph } from "ui/Typography"

const PaymentProviders = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams("")
  const [activeKey, setActiveKey] = useState("1")

  useEffect(() => {
    const tabParam = searchParams.get("tab")
    if (tabParam === PAYPAL_TAB && isFeatureEnabled('PAYPAL_SUPPORT')) {
      setActiveKey("2")
    } else {
      setActiveKey("1")
    }
  }, [searchParams])

  const handleTabChange = (key) => {
    setActiveKey(key)
    if (key === "2") {
      setSearchParams({ tab: PAYPAL_TAB })
    } else {
      setSearchParams({ tab: STRIPE_TAB })
    }
  }

  const items = [
    {
      key: "1",
      label: t("guide.settings.stripe"),
      children: <StripeAccount />
    },
    ...(isFeatureEnabled('PAYPAL_SUPPORT') ? [{
      key: "2",
      label: t("pro.settings.paypal.text"),
      children: <PaypalAccount />
    }] : [])
  ]

  return (
    <Flex vertical>
      <Paragraph size="md">{t("pro.settings.paymentProviders.description")}</Paragraph>
      <Tabs className={styles.paymentProvidersTabs} activeKey={activeKey} items={items} onChange={handleTabChange} />
    </Flex>
  )
}

export default PaymentProviders
